export default __webpack_public_path__ + "static/media/android-tv.6ac71886.png";